module.exports = __webpack_public_path__ + "img/one_click_outcome_reporting.fd0397a9.png";